export interface MainIdeaMeadowAsset {
  readonly key: string; readonly path: string; readonly width: number; readonly height: number;
  readonly alpha: boolean; readonly required: true;
}

const ROOT = 'assets/story-forest/main-idea-meadow';
const image = (key: string, path: string, width: number, height: number, alpha: boolean): MainIdeaMeadowAsset => ({
  key, path: `${ROOT}/${path}`, width, height, alpha, required: true,
});

export const MAIN_IDEA_MEADOW_ASSETS = {
  dormant: image('main-idea-meadow-dormant', 'backgrounds/main-idea-meadow-dormant.png', 1280, 720, false),
  restored: image('main-idea-meadow-restored', 'backgrounds/main-idea-meadow-restored.png', 1280, 720, false),
  detailBloom: image('main-idea-meadow-detail-bloom', 'interactives/detail-bloom.png', 512, 512, true),
} as const;

export const MAIN_IDEA_MEADOW_ASSET_LIST = Object.values(MAIN_IDEA_MEADOW_ASSETS);
export const MAIN_IDEA_MEADOW_PRODUCTION_READY = true;

export function preloadMainIdeaMeadowAssets(scene: Phaser.Scene) {
  MAIN_IDEA_MEADOW_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingMainIdeaMeadowAssets(textures: Phaser.Textures.TextureManager) {
  return MAIN_IDEA_MEADOW_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterMainIdeaMeadow(textures: Phaser.Textures.TextureManager) {
  return MAIN_IDEA_MEADOW_PRODUCTION_READY && getMissingMainIdeaMeadowAssets(textures).length === 0;
}
